/**
 * Normalize string to be used as a key to remove extra spaces and make it lowercase
 *  to ease potential matching
 */
export const flatCleanString = (keyOrNameOrUnknown: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  return (keyOrNameOrUnknown || "").toString().toLowerCase().replace(/\s+/g, "").replace(/-/g, "");
};
